/**
 * 围栏名称模块
 * 创建时间：2017-05-13
 * 创建人：baixx
 */
<template>
    <div class="wrapper-content fadeInRight animated tabBox" id="hellVehicle-list">
        <div class="ibox-content">	 
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">围栏名称</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model="queryParam.areaName" readonly>
					</div>
					<label class="col-sm-1 control-label" v-if="queryParam.areaSize != 0">围栏面积(㎡)</label>
					<div class="col-sm-2" v-if="queryParam.areaSize != 0">
						<input type="text" class="form-control" v-model="queryParam.areaSize" readonly>
					</div>
						<label class="col-sm-1 control-label">围栏创建时间</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model="queryParam.createTime" readonly>
					</div>
					<label class="col-sm-1 control-label">创建人</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model="queryParam.createName" readonly>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
			</div>
			<!--表格开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr>
							<th>序号</th>
							<th>服务号</th>
							<th>车牌号</th>
							<th>车型车系</th>
							<th>驾驶人</th>
					<!--	<th>驾驶起始时间</th>
							<th>监控时长</th>-->	
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(fileInfo,index) in fileInfoList" v-bind:key="index">
							<td>{{index+1}}</td>
							<td>{{fileInfo.vehicleAccount}}</td>
							<td>{{fileInfo.plateNumber}}</td>
							<td>{{fileInfo.vehicleTypeSerie}}</td>
							<td>{{fileInfo.ownerName}}</td>
						<!--<td>{{fileInfo.createTime}}</td>
							<td>{{fileInfo.monitorTime}}</td>-->	
							<td class="text-center">
								<a @click="addTab(fileInfo.plateNumber,fileInfo.vehicleId)">详情</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>	
			 <pagination v-if="showTable" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
			</div>
		   	<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
		</div>
</template>

<script>
    import Pagination from 'components/common/Pagination'
    import TabModal from 'components/common/TabModal'
    import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import classlist from 'util/classlist'
	import {goTabMixin} from 'util/util'
	export default {
		name: 'PageFenceMonitorVehicle',
		mixins:[goTabMixin],
		components: {
			Pagination,
			TabModal,
		},
		data() {
			return {
				vehicleId:'',											//车辆id
				fileInfoList:[],										// 查询结果
				showTable:false,
				pageInfo:{},
				queryParam:{											// 查询参数
					areaName: "",										// 围栏名称
					areaSize: "",							        	// 围栏面积
					createTime: "",                                 		// 围栏创建时间
					createName: "",		                                // 品牌分组ID
					monitorAreaVehicleList:{}
				},
				paramIndex:{
					page_index:1,
				},
				messageStr: "",					                        // 弹出框内容	
				scrollTop: '0'
			};
		},
		// 接收参数车辆ID
		created(){
			this.vehicleId = this.$route.query.id;
		},
		beforeMount(){
			//初始化信息
			this.getTableInfo();
		},
		methods:{
			//初始化信息
			getTableInfo:function(){
				this.$http.get(process.env.API_ROOT + '/monitor/areas/' + this.vehicleId + '/vehicles', {params:this.paramIndex})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;	
						this.showTable = true;
						const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo.monitorAreaVehicleList;
						this.pageInfo = {
							pageNum: pageNum,
							pages: pages,
							total: total,
							isFirstPage: isFirstPage,
							isLastPage: isLastPage
						}
						this.queryParam = resInfo;
						this.fileInfoList = resInfo.monitorAreaVehicleList.list;
					} else {
						this.openModalMsg(res.body.message);
					}
				}, res => {
					this.openModalMsg(res.body.message);
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})
			},
		    getPageNo:function(param){//从分页组件获取页码参数
			   this.paramIndex.page_index = param;
				this.getTableInfo();
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#hellVehicle-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#hellVehicle-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
        	addTab(plateNumber,id){
				 this.openDidiCarFile(plateNumber,id)
			},
		}
	};
</script>



// WEBPACK FOOTER //
// PageFenceMonitorVehicle.vue?2a4154f0